<template>
  <ConsentNotice>
    Ich bin einverstanden, dass die ista Express Service GmbH mir nach dem
    Termin einmalig einen Link zur Zufriedenheitsumfrage an die angegebenen
    Kontaktdaten sendet. Die Einwilligung ist jederzeit widerrufbar. Weitere
    Informationen finden sich in der
    <BaseLink
      url="https://www.istaexpress.de/datenschutz.html"
      external
    >
      {{}} Datenschutzerklärung.
    </BaseLink>
  </ConsentNotice>
</template>

<script setup lang="ts">
import BaseLink from '~/base/components/link/Link.vue'
import ConsentNotice from '~/base/components/consentNotice/ConsentNotice.vue'
</script>
